document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');

if (menuToggle && menu) {
  menuToggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(isOpen));
  });
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const script = form.closest('.product-info')?.querySelector('[data-product-variants]');
  if (!script) return;

  const variants = JSON.parse(script.textContent);
  const idInput = form.querySelector('input[name="id"]');
  const submitButtons = form.querySelectorAll('button[type="submit"]');
  const productInfo = form.closest('.product-info');
  const priceWrapper = productInfo?.querySelector('[data-product-price-wrapper]');
  const priceEl = priceWrapper?.querySelector('[data-product-price]');
  const comparePriceEl = priceWrapper?.querySelector('[data-product-compare-price]');
  const skuEl = productInfo?.querySelector('[data-product-sku]');
  const availabilityEl = productInfo?.querySelector('[data-product-availability]');
  const mobilePriceEl = productInfo?.querySelector('[data-mobile-product-price]');
  const mobileAvailabilityEl = productInfo?.querySelector('[data-mobile-product-availability]');
  const currency = window.Shopify?.currency?.active || 'CAD';
  const locale = document.documentElement.lang || 'en-CA';
  const money = new Intl.NumberFormat(locale, { style: 'currency', currency });

  form.addEventListener('change', () => {
    const selectedOptions = Array.from(form.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
    const selectedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!selectedVariant || !idInput) return;

    idInput.value = selectedVariant.id;
    submitButtons.forEach((submit) => {
      submit.disabled = !selectedVariant.available;
      submit.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
    });

    const formattedPrice = money.format(selectedVariant.price / 100);
    if (priceEl) priceEl.textContent = formattedPrice;
    if (mobilePriceEl) mobilePriceEl.textContent = formattedPrice;

    if (comparePriceEl) {
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        comparePriceEl.textContent = money.format(selectedVariant.compare_at_price / 100);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.hidden = true;
      }
    }

    if (skuEl) skuEl.textContent = selectedVariant.sku || 'See variant';
    if (availabilityEl) availabilityEl.textContent = selectedVariant.available ? 'In stock' : 'Out of stock';
    if (mobileAvailabilityEl) mobileAvailabilityEl.textContent = selectedVariant.available ? 'In stock' : 'Out of stock';
  });
});

document.querySelectorAll('[data-product-gallery-root]').forEach((root) => {
  const dialog = root.querySelector('[data-product-lightbox]');
  const openButtons = Array.from(root.querySelectorAll('[data-gallery-open]'));
  const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-gallery-jump]'));
  const closeButton = root.querySelector('[data-gallery-close]');
  const prevButton = root.querySelector('[data-gallery-prev]');
  const nextButton = root.querySelector('[data-gallery-next]');

  if (!dialog || !openButtons.length || !slides.length) return;

  let activeIndex = 0;

  const setActiveSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== activeIndex;
    });

    thumbs.forEach((thumb, thumbIndex) => {
      if (thumbIndex === activeIndex) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  };

  const openGallery = (index) => {
    setActiveSlide(index);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    closeButton?.focus();
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      openGallery(Number(button.dataset.galleryOpen || 0));
    });
  });

  thumbs.forEach((button) => {
    button.addEventListener('click', () => {
      setActiveSlide(Number(button.dataset.galleryJump || 0));
    });
  });

  prevButton?.addEventListener('click', () => setActiveSlide(activeIndex - 1));
  nextButton?.addEventListener('click', () => setActiveSlide(activeIndex + 1));
  closeButton?.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') setActiveSlide(activeIndex - 1);
    if (event.key === 'ArrowRight') setActiveSlide(activeIndex + 1);
  });
});
